import { SelectOption } from "components/dropdown/Dropdown";
import { AddressComponent, AddressMapData, ResponseComponent } from "./models";
import { FieldInputProps } from "formik";
import _ from "lodash";
import instance from "api";
import { endpoints } from "config";
import { useEffect, useState } from "react";
import { SiteFields } from "pages/Sites/models";

const deepCopy = (selectArray: SelectOption[] | null) => {
  if (selectArray) {
    return selectArray.map((option: SelectOption) => {
      return { ...option };
    });
  } else {
    return null;
  }
};
export const clearMapData = (field: FieldInputProps<AddressMapData>) => {
  let newFieldValue: AddressMapData = { ...field.value };

  Object.keys(newFieldValue).forEach((key: string) => {
    if (key !== "countries" && key !== "usStates") {
      newFieldValue[key as keyof AddressMapData] = null;
    }
  });
  return newFieldValue;
};

export const findCountry = (country: string, countries: SelectOption[]) => {
  const matchCountry = countries.filter(
    (countryLabel: SelectOption) => countryLabel.label === country
  )[0];
  if (matchCountry) {
    return matchCountry.value;
  }
};

export const findStateId = (usState: string, usStates: SelectOption[]) => {
  const matchState = usStates.filter(
    (usStateOption: SelectOption) => usStateOption.label === usState
  )[0];
  if (matchState) {
    return matchState.value;
  }
};

export const nullField = (mapData: AddressMapData) => {
  let isNull: boolean = true;
  Object.values(mapData).forEach(value => {
    if (
      typeof value !== "object" &&
      value != null &&
      value !== undefined &&
      value !== ""
    ) {
      isNull = false;
      return;
    }
  });
  return isNull;
};

export const autoFillAddress = (
  responseComponents: ResponseComponent,
  field: FieldInputProps<AddressMapData>,
  currentAddress?: AddressMapData
) => {
  let tempAddressObject: AddressMapData = currentAddress
    ? _.cloneDeep(currentAddress)
    : {
        address: null,
        city: null,
        countries: deepCopy(field.value.countries),
        countriesId: null,
        latitude: null,
        longitude: null,
        postalZipCode: null,
        region: null,
        stateProvince: null,
        usStates: deepCopy(field.value.usStates),
        usStatesID: null,
      };

  tempAddressObject = {
    ...tempAddressObject,
    latitude: parseFloat(responseComponents.geometry.location.lat),
  };
  tempAddressObject = {
    ...tempAddressObject,
    longitude: parseFloat(responseComponents.geometry.location.lng),
  };
  
  // IXSTD-4717: Removed code block to overwrite address fields
 
  return tempAddressObject;
};

export const useUpdateCoordinates = (
  address: AddressMapData | null,
  Id: number | null
) => {
  const [siteForm, setSiteForm] = useState<SiteFields | null>(null);

  useEffect(() => {
    if (Id && address) {
      (async () => {
        try {
          const formFetch = await instance.get(endpoints.sites.editSites, {
            params: { Id },
          });
          if (formFetch.status === 200 && formFetch.data.status === "1") {
            setSiteForm(formFetch.data.details);
          }
        } catch (err) {}
      })();
    }
  }, [Id, address]);

  useEffect(() => {
    if (siteForm && address) {
      siteForm.addressMap = address;
      (async () => {
        try {
          const result = await instance.post(endpoints.sites.editSites, {
            ...siteForm,
          });
        } catch (err) {}
      })();
    }
  }, [siteForm, address]);
};
